import React, { memo } from "react";
import events from "@/components/Joyspace/context/events";
import Icon from "@/components/Joyspace/Icon";
import styles from "./index.module.less";

const CollapseBtn = memo(
  ({
    collapse,
    setCollapse
  }: {
    collapse: boolean;
    setCollapse: React.Dispatch<React.SetStateAction<boolean>>;
  }) => {
    return (
      <div
        className={`${styles["collapse-space"]}  ${collapse ? styles["collapsed-space"] : ""}`}
        onClick={() => {
          setCollapse((pre) => {
            return !pre;
          });
          events.emit("left-nav-resize");
        }}
      >
        {collapse ? (
          <Icon type="iconzhankaishouqi" className={styles["icon-zhankai"]} />
        ) : (
          <Icon type="iconzhankaishouqi" />
        )}
      </div>
    );
  }
);
export default CollapseBtn;
